import React from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '../formComponents/dropDown'
import moment from 'moment'
const Filters = ({data,onFiltersChange})=>{
    const initialiseLast3Yrs=()=>{
          const currentYear=moment().year()
          return [3,2,1,0].map((item,index)=>({id:index+1,text:currentYear-item,value:(currentYear-item)?.toString(),text_nl:currentYear-item,text_es:currentYear-item,value:(currentYear-item)?.toString()}))
    }
    const [yearDs,]=React.useState(initialiseLast3Yrs())
    const monthDs=React.useRef([{id:1,text:"JANUARY",text_nl:"JANUARY",text_es:"JANUARY",value:"1"},{id:2,text:"FEBRUARY",text_nl:"FEBRUARY",text_es:"JANUARY",value:"2"},{id:3,text:"MARCH",text_nl:"MARCH",text_es:"MARCH",value:"3"},{id:4,text:"APRIL",text_nl:"APRIL",text_es:"APRIL",value:"4"},{id:5,text:"MAY",text_nl:"MAY",text_es:"MAY",value:"5"},{id:6,text:"JUNE",text_nl:"JUNE",text_es:"JUNE",value:"6"},{id:7,text:"JULY",text_nl:"JULY",text_es:"JULY",value:"7"},{id:8,text:"AUGUST",text_nl:"AUGUST",text_nl:"AUGUST",value:"8"},{id:9,text:"SEPTEMBER",text_nl:"SEPTEMBER",text_es:"SEPTEMBER",value:"9"},{id:10,text:"OCTOBER",text_nl:"OCTOBER",text_es:"OCTOBER",value:"10"},{id:11,text:"NOVEMBER",text_nl:"NOVEMBER",text_es:"NOVEMBER",value:"11"},{id:12,text:"DECEMBER",text_nl:"DECEMBER",text_es:"DECEMBER",value:"12"}])
    

    return(
        <Grid  columns='equal'>
    <Grid.Row>
    <Grid.Column>
    <DropDown
                    id="year"
                    label="year"
                    className='field-bg dropdown100 border-none'
                    labelClass='text-none'
                    isLabel={true}
                    data={yearDs}
                    displayType={false}
                    value={data.year}
                    onChange={(value)=>onFiltersChange(prev=>({...prev,year:value}))}
                    />
          </Grid.Column>    
    
            <Grid.Column>
            <DropDown
                    id="month"
                    label="Month"
                    className='field-bg dropdown100 border-none'
                    labelClass='text-none'
                    displayType={false}
                    isLabel={true}
                    data={monthDs.current}
                    value={data.month}
                    onChange={(value)=>onFiltersChange(prev=>({...prev,month:value}))}
                    />
               
         </Grid.Column>
    </Grid.Row>
   </Grid>
    )
}

export default Filters